import { setCartPhrase } from '../../apis/firebase';
import { ERROR_ADD_CART_MESSAGE } from '../../constants';
import { sendCloudWatchAlert } from '../../utils/applicationError';
import 'rc-time-picker/assets/index.css';
import 'react-datepicker/dist/react-datepicker.css';

export const initDataConfig = async (newProps, component) => {
  const { cartPhrase } = newProps;
  await component.setState({ newCartPhrase: cartPhrase });
};

export const handleChangeCartPhrase = async component => {
  const { newCartPhrase = '' } = component.state;
  const { openErrorModal } = component.props;
  const returnCartPhrase = newCartPhrase.length === 0 ? null : newCartPhrase;
  try {
    await setCartPhrase(returnCartPhrase);
    handleClose(component);
  } catch (error) {
    sendCloudWatchAlert(`Error changing cart phrase ${error}`);
    openErrorModal(ERROR_ADD_CART_MESSAGE);
  }
};

export const handleClose = component => {
  component.setState({ cartPhraseModal: false });
};
